import { render } from "./About.vue?vue&type=template&id=773c302a"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./About.vue?vue&type=style&index=0&id=773c302a&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__